import InvestorSecondaryMarket from './investor-secondary-market';

export default InvestorSecondaryMarket;
